<template>
  <div class="main-content" ref="sub">
    <vxe-toolbar size="mini">
      <template v-slot:buttons>
        <template v-for="item in menuButtonList">
          <vxe-button
            type="primary"
            :icon="item.attributes.buttonStyle"
            :style="
              'background-color:' +
              (item.label == '删除' || item.label == '禁用' ? '#FE8783' : 'rgb(98, 153, 254)') +
              ';border:1px solid ' +
              (item.label == '删除' || item.label == '禁用' ? '#FE8783' : 'rgb(98, 153, 254)')
            "
            :key="item.id"
            :disabled="item.isDisabled"
            @click="chooseClick(item.attributes.buttonUrl, item)"
            >{{ item.label }}</vxe-button
          >
        </template>
      </template>
    </vxe-toolbar>
    <vxe-grid
      border
      show-overflow
      resizable
      ref="xTable"
      class="vxe-table-element"
      size="mini"
      align="left"
      :loading="load"
      :auto-resize="true"
      :data="tableData"
      @select-change="handleSelectionChange"
      @select-all="handleSelectionChange"
    >
      <vxe-table-column type="checkbox" width="60"></vxe-table-column>
      <vxe-table-column type="index" width="60" :title="$t('table.index')"></vxe-table-column>
      <vxe-table-column
        field="factorCode"
        :title="$t('formulaFactors.table.factorCode')"
      ></vxe-table-column>
      <vxe-table-column
        field="factorName"
        :title="$t('formulaFactors.table.factorName')"
      ></vxe-table-column>
      <vxe-table-column field="factorStatus" :title="$t('formulaFactors.table.factorStatus')">
        <template slot-scope="scope">
          <span>
            {{
              scope.row['factorStatus'] == 'Y'
                ? $t('formulaFactors.msg.enable')
                : $t('formulaFactors.msg.disable')
            }}
          </span>
        </template>
      </vxe-table-column>
    </vxe-grid>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import API from '@/api/purchaseSalesCenter/customerBalance/customerBalance';
  export default {
    name: 'formulaFactors',
    components: {},
    data() {
      return {
        menuButtonList: [], // 按钮
        load: false,
        tableData: [],
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
    },
    created() {
      this.getData();
      this.getButtonList();
    },
    methods: {
      //获取数据
      getData() {
        this.$axios.post(API.QUERY_FACTOR_LIST, {}).then((res) => {
          this.load = false;
          if (0 == res.data.code) {
            this.tableData = res.data.data;
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      chooseClick(type) {
        if (type == 'save') {
          //this.handleSave();
        } else if (type == 'enable' || type == 'disable') {
          this.handleOperate(type);
        }
      },
      handleOperate(type) {
        // 启用禁用因子
        if (this.multipleSelection.length == 0) {
          return this.$message({
            showClose: true,
            type: 'info',
            message: this.$t('message.noData'),
          });
        }
        let ids = this.multipleSelection.map((item) => {
          return item.id;
        });

        this.$confirmAction(
          this.$t(`formulaFactors.msg.${type == 'enable' ? 'enableConfirm' : 'disableConfirm'}`),
          this.$t(`formulaFactors.msg.${type == 'enable' ? 'isEnable' : 'isDisable'}`)
        )
          .then(() => {
            this.commonRequest(type == 'enable' ? 'ENABLE_FACTOR' : 'DISABLE_FACTOR', ids);
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      commonRequest(apiName, params) {
        this.loading.startLoading();
        this.$axios.post(API[apiName], params).then((res) => {
          this.loading.endLoading();
          if (0 == res.data.code) {
            this.$message({ showClose: true, message: res.data.msg, type: 'success' });
            this.getData();
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      getButtonList() {
        //获取菜单按钮
        this.getButtons().then((res) => {
          this.menuButtonList = res;
        });
      },
      handleSelectionChange(val) {
        // 选中事件
        this.multipleSelection = val.selection;
        if (this.multipleSelection.length == 0)
          return this.menuButtonList.forEach((item) => {
            item.isDisabled = false;
          });
        let flag1 = this.multipleSelection.every((item) => {
          return item.factorStatus == 'Y';
        });
        let flag2 = this.multipleSelection.every((item) => {
          return item.factorStatus == 'N';
        });

        if (flag1) {
          this.menuButtonList.forEach((item) => {
            if (item.attributes.buttonUrl === 'enable') {
              item.isDisabled = true;
            } else {
              item.isDisabled = false;
            }
          });
        } else if (flag2) {
          this.menuButtonList.forEach((item) => {
            if (item.attributes.buttonUrl == 'disable') {
              item.isDisabled = true;
            } else {
              item.isDisabled = false;
            }
          });
        } else {
          this.menuButtonList.forEach((item) => {
            if (item.attributes.buttonUrl == 'enable' || item.attributes.buttonUrl == 'disable') {
              item.isDisabled = true;
            }
          });
        }
      },
    },
  };
</script>
